"use strict";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.teenyRequest = exports.RequestError = void 0;

var node_fetch_1 = require("node-fetch");

var stream_1 = require("stream");

var uuid = require("uuid");

var agents_1 = require("./agents");

var TeenyStatistics_1 = require("./TeenyStatistics"); // eslint-disable-next-line @typescript-eslint/no-var-requires


var streamEvents = require('stream-events');

var RequestError =
/*#__PURE__*/
function (_Error) {
  _inherits(RequestError, _Error);

  function RequestError() {
    _classCallCheck(this, RequestError);

    return _possibleConstructorReturn(this, _getPrototypeOf(RequestError).apply(this, arguments));
  }

  return RequestError;
}(_wrapNativeSuper(Error));

exports.RequestError = RequestError;
/**
 * Convert options from Request to Fetch format
 * @private
 * @param reqOpts Request options
 */

function requestToFetchOptions(reqOpts) {
  var options = _objectSpread({
    method: reqOpts.method || 'GET'
  }, reqOpts.timeout && {
    timeout: reqOpts.timeout
  }, {}, typeof reqOpts.gzip === 'boolean' && {
    compress: reqOpts.gzip
  });

  if (typeof reqOpts.json === 'object') {
    // Add Content-type: application/json header
    reqOpts.headers = reqOpts.headers || {};
    reqOpts.headers['Content-Type'] = 'application/json'; // Set body to JSON representation of value

    options.body = JSON.stringify(reqOpts.json);
  } else {
    if (Buffer.isBuffer(reqOpts.body)) {
      options.body = reqOpts.body;
    } else if (typeof reqOpts.body !== 'string') {
      options.body = JSON.stringify(reqOpts.body);
    } else {
      options.body = reqOpts.body;
    }
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  options.headers = reqOpts.headers;
  var uri = reqOpts.uri || reqOpts.url;

  if (!uri) {
    throw new Error('Missing uri or url in reqOpts.');
  }

  if (reqOpts.useQuerystring === true || typeof reqOpts.qs === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var qs = require('querystring');

    var params = qs.stringify(reqOpts.qs);
    uri = uri + '?' + params;
  }

  options.agent = agents_1.getAgent(uri, reqOpts);
  return {
    uri: uri,
    options: options
  };
}
/**
 * Convert a response from `fetch` to `request` format.
 * @private
 * @param opts The `request` options used to create the request.
 * @param res The Fetch response
 * @returns A `request` response object
 */


function fetchToRequestResponse(opts, res) {
  var request = {};
  request.agent = opts.agent || false;
  request.headers = opts.headers || {};
  request.href = res.url; // headers need to be converted from a map to an obj

  var resHeaders = {};
  res.headers.forEach(function (value, key) {
    return resHeaders[key] = value;
  });
  var response = Object.assign(res.body, {
    statusCode: res.status,
    statusMessage: res.statusText,
    request: request,
    body: res.body,
    headers: resHeaders,
    toJSON: function toJSON() {
      return {
        headers: resHeaders
      };
    }
  });
  return response;
}
/**
 * Create POST body from two parts as multipart/related content-type
 * @private
 * @param boundary
 * @param multipart
 */


function createMultipartStream(boundary, multipart) {
  var finale = "--".concat(boundary, "--");
  var stream = new stream_1.PassThrough();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = multipart[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var part = _step.value;
      var preamble = "--".concat(boundary, "\r\nContent-Type: ").concat(part['Content-Type'], "\r\n\r\n");
      stream.write(preamble);

      if (typeof part.body === 'string') {
        stream.write(part.body);
        stream.write('\r\n');
      } else {
        part.body.pipe(stream, {
          end: false
        });
        part.body.on('end', function () {
          stream.write('\r\n');
          stream.write(finale);
          stream.end();
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return stream;
}

function teenyRequest(reqOpts, callback) {
  var _requestToFetchOption = requestToFetchOptions(reqOpts),
      uri = _requestToFetchOption.uri,
      options = _requestToFetchOption.options;

  var multipart = reqOpts.multipart;

  if (reqOpts.multipart && multipart.length === 2) {
    if (!callback) {
      // TODO: add support for multipart uploads through streaming
      throw new Error('Multipart without callback is not implemented.');
    }

    var boundary = uuid.v4();
    options.headers['Content-Type'] = "multipart/related; boundary=".concat(boundary);
    options.body = createMultipartStream(boundary, multipart); // Multipart upload

    teenyRequest.stats.requestStarting();
    node_fetch_1.default(uri, options).then(function (res) {
      teenyRequest.stats.requestFinished();
      var header = res.headers.get('content-type');
      var response = fetchToRequestResponse(options, res);
      var body = response.body;

      if (header === 'application/json' || header === 'application/json; charset=utf-8') {
        res.json().then(function (json) {
          response.body = json;
          callback(null, response, json);
        }, function (err) {
          callback(err, response, body);
        });
        return;
      }

      res.text().then(function (text) {
        response.body = text;
        callback(null, response, text);
      }, function (err) {
        callback(err, response, body);
      });
    }, function (err) {
      teenyRequest.stats.requestFinished();
      callback(err, null, null);
    });
    return;
  }

  if (callback === undefined) {
    // Stream mode
    var requestStream = streamEvents(new stream_1.PassThrough()); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    var responseStream;
    requestStream.once('reading', function () {
      if (responseStream) {
        responseStream.pipe(requestStream);
      } else {
        requestStream.once('response', function () {
          responseStream.pipe(requestStream);
        });
      }
    });
    options.compress = false;
    teenyRequest.stats.requestStarting();
    node_fetch_1.default(uri, options).then(function (res) {
      teenyRequest.stats.requestFinished();
      responseStream = res.body;
      responseStream.on('error', function (err) {
        requestStream.emit('error', err);
      });
      var response = fetchToRequestResponse(options, res);
      requestStream.emit('response', response);
    }, function (err) {
      teenyRequest.stats.requestFinished();
      requestStream.emit('error', err);
    }); // fetch doesn't supply the raw HTTP stream, instead it
    // returns a PassThrough piped from the HTTP response
    // stream.

    return requestStream;
  } // GET or POST with callback


  teenyRequest.stats.requestStarting();
  node_fetch_1.default(uri, options).then(function (res) {
    teenyRequest.stats.requestFinished();
    var header = res.headers.get('content-type');
    var response = fetchToRequestResponse(options, res);
    var body = response.body;

    if (header === 'application/json' || header === 'application/json; charset=utf-8') {
      if (response.statusCode === 204) {
        // Probably a DELETE
        callback(null, response, body);
        return;
      }

      res.json().then(function (json) {
        response.body = json;
        callback(null, response, json);
      }, function (err) {
        callback(err, response, body);
      });
      return;
    }

    res.text().then(function (text) {
      var response = fetchToRequestResponse(options, res);
      response.body = text;
      callback(null, response, text);
    }, function (err) {
      callback(err, response, body);
    });
  }, function (err) {
    teenyRequest.stats.requestFinished();
    callback(err, null, null);
  });
  return;
}

exports.teenyRequest = teenyRequest;

teenyRequest.defaults = function (defaults) {
  return function (reqOpts, callback) {
    var opts = _objectSpread({}, defaults, {}, reqOpts);

    if (callback === undefined) {
      return teenyRequest(opts);
    }

    teenyRequest(opts, callback);
  };
};
/**
 * Single instance of an interface for keeping track of things.
 */


teenyRequest.stats = new TeenyStatistics_1.TeenyStatistics();

teenyRequest.resetStats = function () {
  teenyRequest.stats = new TeenyStatistics_1.TeenyStatistics(teenyRequest.stats.getOptions());
};